export function addClassToDocumentAtScrollY(className = 'scrolled', position = 100) {
  document.documentElement.classList.toggle(className, window.scrollY > position);
  window.addEventListener('scroll', () => {
    document.documentElement.classList.toggle(className, window.scrollY > position);
  }, {
    passive: true
  });
}